module.exports = __webpack_public_path__ + "static/media/ve.d384c6ce.svg";